import { render, staticRenderFns } from "./RuleTargetRoas.vue?vue&type=template&id=98076fa0"
import script from "./RuleTargetRoas.vue?vue&type=script&lang=js"
export * from "./RuleTargetRoas.vue?vue&type=script&lang=js"
import style0 from "./RuleTargetRoas.vue?vue&type=style&index=0&id=98076fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports